module.exports = __webpack_public_path__ + "img/img23.27d663b1.png";